var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label_input_wrapper"},[_c('label',{staticClass:"f_gray_4"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._v(" "),_c('input',{attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.handleChange}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-635ec910","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ai/AiLabelInput.vue
// module id = null
// module chunks = 